import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { List, ListItem, ListItemText, Chip } from '@material-ui/core';
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import PresupuestoDetalladoEditModal from "./PresupuestoDetalladoEditModal.js";
import ValidacionAutomaticaTooltip from './ValidacionAutomaticaTooltip.jsx'
import MessageTooltip from '../ui/commons/tooltip/MessageTooltip.jsx'
import Dialog from '../../commons/dialog/Dialog';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90vw',
	maxWidth: 500,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
};

function Row(props) {
	const intl = props.intl;
	const [presupuestoTarea, setPresupuestoTarea] = useState(props.presupuestoTarea);
	const [showModalEdit, setShowModalEdit] = useState(false);

	const [isMecanicoDropdownOpen, setIsMecanicoDropdownOpen] = useState(false);
	const [mecanicoSearchInput, setMecanicoSearchInput] = useState('');
	const [selectedMecanicos, setSelectedMecanicos] = useState(
		props.presupuestoTarea.mecanico_ids ? props.presupuestoTarea.mecanico_ids : []
	);
	const mecanicoDropdownRef = useRef(null);

	useEffect(function() {
		function handleClickOutside(e) {
			if (mecanicoDropdownRef.current && !mecanicoDropdownRef.current.contains(e.target)) {
				setIsMecanicoDropdownOpen(false);
				setMecanicoSearchInput('');
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return function() {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const mecanicosFiltrados = (props.mecanicos || []).filter(function(m) {
		if (!mecanicoSearchInput) return true;
		var search = mecanicoSearchInput.toLowerCase();
		return m.nombreCompleto && m.nombreCompleto.toLowerCase().indexOf(search) !== -1;
	});

	const handleSelectMecanico = function(mecanico) {
		var yaSeleccionado = selectedMecanicos.find(function(m) { return m.id === mecanico.id; });
		if (yaSeleccionado) return;
		var nuevos = selectedMecanicos.concat([mecanico]);
		setSelectedMecanicos(nuevos);
		setMecanicoSearchInput('');
		var updatedTarea = JSON.parse(JSON.stringify(presupuestoTarea));
		updatedTarea.mecanico_ids = nuevos.map(function(m) { return m.id; });
		setPresupuestoTarea(updatedTarea);
		props.updatePresupuestoTarea({ mecanico_ids: updatedTarea.mecanico_ids }, props.index);
	};

	const handleDeleteMecanico = function(mecanico) {
		var nuevos = selectedMecanicos.filter(function(m) { return m.id !== mecanico.id; });
		setSelectedMecanicos(nuevos);
		var updatedTarea = JSON.parse(JSON.stringify(presupuestoTarea));
		updatedTarea.mecanico_ids = nuevos.map(function(m) { return m.id; });
		setPresupuestoTarea(updatedTarea);
		props.updatePresupuestoTarea({ mecanico_ids: updatedTarea.mecanico_ids }, props.index);
	};

	const useStyles = makeStyles((theme) => ({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			borderRadius: "15px",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0px solid #000",
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
			borderRadius: "15px",
		},
	}));

	const classEdit = useStyles();

	const aplicarCambio = (data) => {
		props.updatePresupuestoTarea(data, props.index);
		presupuestoTarea.precio = data.costo;
		presupuestoTarea.cantidad = data.cantidad;
		presupuestoTarea.detalle = data.detalle;
		if (data.clasificacion !== undefined) presupuestoTarea.clasificacion = data.clasificacion;
		if (data.id_clasificacion !== undefined) presupuestoTarea.id_clasificacion = data.id_clasificacion;
		closeModalEdit();
	};

	const updateElement = (data) => {
		if (presupuestoTarea.estado_recotizacion === 'aprobado') {
			Dialog.confirm(
				intl,
				{
					title: intl.formatMessage({ id: 'recotizacion.warning.titulo', defaultMessage: 'Mano de obra aprobada' }),
					text: intl.formatMessage({ id: 'recotizacion.warning.texto', defaultMessage: 'Esta mano de obra fue aprobada en la revisión. ¿Confirmás que querés modificarla?' }),
					icon: 'warning',
					confirmText: intl.formatMessage({ id: 'recotizacion.warning.confirmar', defaultMessage: 'Sí, modificar' }),
					cancelText: intl.formatMessage({ id: 'recotizacion.warning.cancelar', defaultMessage: 'Cancelar' }),
				},
				() => { aplicarCambio(data); }
			);
		} else {
			aplicarCambio(data);
		}
	};

	const total = () => {
		let total = null;
		if(presupuestoTarea.cantidad !== null){
			if(presupuestoTarea.precio !== null){
				total = presupuestoTarea.cantidad * presupuestoTarea.precio;
			}
		}
		return total;
	};

	const closeModalEdit = () => {
		setShowModalEdit(false);
	};

	const renderTableTbody = (field, index) => {
		switch (field) {
			case 'index':
				return (
					<td key={index} className="all custom-lineHeight">
						{props.index + 1}
					</td>
				);
			case 'id':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoTarea.id_tarea}
					</td>
				);
			case 'external_code':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoTarea.external_code}
					</td>
				);
			case 'nombre':
				return (
					<td key={index} className="all custom-lineHeight" style={{ maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={presupuestoTarea.nombre}>
						{presupuestoTarea.nombre}
						{presupuestoTarea.estado_recotizacion === 'rechazado' && presupuestoTarea.comentario_rechazo ? (
							<MessageTooltip message={presupuestoTarea.comentario_rechazo} color="warning" />
						) : null}
					</td>
				);
			case 'clasificacion':
				// `presupuesto_tareas` no persiste ni devuelve clasificación.
				// No mostramos esta columna para evitar exponer un dato que se pierde al guardar/recargar.
				return null;
			case 'detalle':
				return (
					<td key={index} className="all custom-lineHeight" style={{ maxWidth: '130px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={presupuestoTarea.detalle}>
						{presupuestoTarea.detalle}
					</td>
				);
			case 'cuenta_mayor':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoTarea.cuenta_mayor}
					</td>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoTarea.cuenta_mayor_descripcion}
					</td>
				);
			case 'cantidad':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoTarea.cantidad}
					</td>
				);
			case 'precio':
				return (
					<td key={index} className="all custom-lineHeight">
						{presupuestoTarea.precio !== null ? parseFloat(presupuestoTarea.precio).toFixed(2) : "00.00"}
					</td>
				);
			case 'total':
				return (
					<td key={index} className="all custom-lineHeight">
						{total() !== null ? parseFloat(total()).toFixed(2) : "00.00"}
					</td>
				);
			case 'servicio':
				return (
					<td key={index} className="all custom-lineHeight">
						{
							presupuestoTarea.servicio ?
								presupuestoTarea.servicio.nombre :
								(presupuestoTarea.servicio_nombre ? presupuestoTarea.servicio_nombre : '')
						}
						<ValidacionAutomaticaTooltip element={presupuestoTarea} intl={intl} />
					</td>
				);
			case 'mecanico':
				return (
					<td key={index} className="all custom-lineHeight">
						<div style={{ position: 'relative' }} ref={mecanicoDropdownRef}>
							<div className="d-flex align-items-center">
								<div style={{ fontSize: '0.85rem' }}>
									{selectedMecanicos.length > 0
										? selectedMecanicos.map(function(m) { return m.nombreCompleto; }).join(', ')
										: '-'
									}
								</div>
								<i
									className="fa fa-chevron-down fa-2xs cursor-pointer"
									style={{ marginLeft: '5px', fontSize: '11px' }}
									onClick={function() {
										setIsMecanicoDropdownOpen(function(prev) { return !prev; });
									}}
								/>
							</div>
							{isMecanicoDropdownOpen && (
								<div
									style={{
										position: 'absolute',
										zIndex: 10,
										border: '1px solid #ccc',
										borderRadius: '4px',
										padding: '10px',
										backgroundColor: '#fff',
										minWidth: '220px',
										boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
									}}
								>
									<div style={{ marginBottom: '8px', fontWeight: 'bold', fontSize: '0.85rem' }}>
										<FormattedMessage id="Presupuesto.Mecanicos" defaultMessage="Mecánicos:" />
									</div>
									{selectedMecanicos.length > 0
										? selectedMecanicos.map(function(m, i) {
											return (
												<div key={i} style={{ paddingTop: '2px' }}>
													<Chip
														label={m.nombreCompleto}
														onDelete={function() { handleDeleteMecanico(m); }}
														style={{ marginRight: '5px', fontFamily: 'unset', fontSize: '0.85rem' }}
													/>
												</div>
											);
										})
										: <div style={{ fontSize: '0.8rem', color: '#999', marginBottom: '6px' }}>-</div>
									}
									<div style={{ marginTop: '8px' }}>
										<i className="fa fa-search fa-xs" style={{ marginRight: '4px' }} />
										<input
											className="form-control"
											type="text"
											placeholder={intl.formatMessage({ id: 'Buscar_Mecanico', defaultMessage: 'Buscar mecánico' })}
											value={mecanicoSearchInput}
											onChange={function(e) { setMecanicoSearchInput(e.target.value); }}
											style={{ display: 'inline-block', width: 'calc(100% - 20px)' }}
										/>
									</div>
									<hr style={{ margin: '6px 0' }} />
									<List style={{ paddingTop: 0, paddingBottom: 0, maxHeight: '180px', overflowY: 'auto' }}>
										{mecanicosFiltrados.map(function(m, i) {
											var yaSeleccionado = selectedMecanicos.find(function(s) { return s.id === m.id; });
											return (
												<ListItem
													key={i}
													onClick={function() { handleSelectMecanico(m); }}
													style={{
														cursor: yaSeleccionado ? 'default' : 'pointer',
														paddingTop: '3px',
														paddingBottom: '3px',
														opacity: yaSeleccionado ? 0.4 : 1,
													}}
												>
													<ListItemText primary={m.nombreCompleto} style={{ fontSize: '0.85rem' }} />
												</ListItem>
											);
										})}
									</List>
								</div>
							)}
						</div>
					</td>
				);
			default:
				return null;
		}
	}

	return (
		<React.Fragment>
			<tr key={presupuestoTarea.id} style={presupuestoTarea.estado_recotizacion === 'rechazado' ? { backgroundColor: '#fff3cd' } : {}}>
				<Modal
					open={showModalEdit}
					onClose={closeModalEdit}
					className={classEdit.modal}
					BackdropComponent={Backdrop}
					BackdropProps={{ timeout: 500 }}
				>
					<Fade in={showModalEdit}>
						<Box sx={style}>
							<PresupuestoDetalladoEditModal
								type="presupuestoTarea"
								intl={props.intl}
								element={presupuestoTarea}
								updateElement={updateElement}
								closeModalEdit={closeModalEdit}
								enabledCosto={props.showTareas.includes('precio')}
								enabledCantidad={props.showTareas.includes('cantidad')}
								enabledDetalle={props.showTareas.includes('detalle')}
								enabledClasificacion={props.showTareas.includes('clasificacion')}
								clasificaciones={props.clasificaciones || []}
							/>
						</Box>
					</Fade>
				</Modal>
				{props.showTareas.map((field, index) => renderTableTbody(field, index))}

				<td className="all custom-lineHeight" style={{textAlign: 'center'}}>
					<button
						className="btn btn-sm btn-icon btn-dt-grid text-warning"
						title={intl.formatMessage({ id: 'Presupuesto.Editar', defaultMessage: 'Editar' })}
						data-togle="tooltip"
						data-placement="top"
						onClick={(event) => { setShowModalEdit(true); event.preventDefault(); }}
					>
						<i className="fa fa-pencil fa-xs"/>
					</button>
					<button
						className="btn btn-sm btn-icon btn-dt-grid text-danger"
						title={intl.formatMessage({ id: 'Presupuesto.Eliminar', defaultMessage: 'Eliminar' })}
						data-togle="tooltip"
						data-placement="top"
						onClick={() => props.deleteTarea(props.index)}
					>
						<i className="fa fa-trash fa-xs"></i>
					</button>
				</td>
			</tr>
		</React.Fragment>
	);
}

const PresupuestoDetalladoTareaGrid = (props) => {
	const [loading, setLoading] = useState(false);

	const setLoadingAndUpdate = (state) => {
		setLoading(state);
	};

	const renderTableThead = (field, index) => {
		switch (field) {
			case 'index':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Items" defaultMessage="Items" /></th>;
			case 'id':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Id" defaultMessage="Id" /></th>;
			case 'external_code':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Tarea" defaultMessage="Tarea" /></th>;
			case 'nombre':
				return <th key={index} scope="col" style={{ minWidth: '110px', maxWidth: '160px' }}><FormattedMessage id="Presupuesto.Descripción" defaultMessage="Descripción" /></th>;
			case 'clasificacion':
				return <th key={index} scope="col" style={{ minWidth: '100px', maxWidth: '140px' }}><FormattedMessage id="presupuesto.clasificacion" defaultMessage="Clasificación" /></th>;
			case 'detalle':
				return <th key={index} scope="col" style={{ minWidth: '80px', maxWidth: '130px', width: '80px' }}><FormattedMessage id="Presupuesto.Detalle" defaultMessage="Detalle" /></th>;
			case 'cuenta_mayor':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Cuenta_Mayor" defaultMessage="Cuenta Mayor" /></th>;
			case 'cuenta_mayor_descripcion':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Descripción_Cuenta_Mayor" defaultMessage="Descripción Cuenta Mayor" /></th>;
			case 'cantidad':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Cantidad" defaultMessage="Cantidad" /></th>;
			case 'precio':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Precio" defaultMessage="Precio" /></th>;
			case 'total':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Total" defaultMessage="Total" /></th>;
			case 'servicio':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Servicio" defaultMessage="Servicio" /></th>;
			case 'mecanico':
				return <th key={index} scope="col"><FormattedMessage id="Presupuesto.Mecanico" defaultMessage="Mecánico" /></th>;
			default:
				return null;
		}
	}

	return (
		<React.Fragment>
			<table
				id="dataTable"
				className="dataTable table nowrap server-side table-hover dataTableMovil"
				width="100%"
			>
				<thead>
					<tr>
						{props.showTareas.map((field, index) => renderTableThead(field, index))}
						<th scope="col" style={{textAlign: 'center'}}></th>
					</tr>
				</thead>
				<tbody>
					{props.presupuestoTareas ? (
						props.presupuestoTareas.map((presupuestoTarea, index) => (
							<Row
								index={index}
								intl={props.intl}
								presupuestoTarea={presupuestoTarea}
								loading={(state) => setLoadingAndUpdate(state)}
								key={presupuestoTarea.external_code + presupuestoTarea.nombre + index}
								deleteTarea={props.deleteTarea}
								updatePresupuestoTarea={props.updatePresupuestoTarea}
								showTareas={props.showTareas}
								mecanicos={props.mecanicos}
								clasificaciones={props.clasificaciones || []}
							/>
						))
					) : (
						<tr>
							<td align={"center"} colSpan={14}>
								{loading ? (
									<CircularProgress />
								) : (
									<FormattedMessage
										id="No_hay_datos_disponibles."
										defaultMessage="No hay datos disponibles."
									/>
								)}
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</React.Fragment>
	);
};

export default injectIntl(PresupuestoDetalladoTareaGrid);
